import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { ReactElement } from "react";

import { AssetMetashotsType } from "../../../generated/gql/graphql";
import useText from "../../../hooks/use-text";
import { LocalizedStrings, SupportedLanguages } from "../../../utils/lang";

type Props = {
  className?: string;
  value?: AssetMetashotsType;
  onSelect(value: AssetMetashotsType | "all"): void;
};

export default function MetashotTypeFilter(props: Props): ReactElement {
  const { className, value, onSelect } = props;

  const { strings } = useText(local);

  const options = Object.keys(AssetMetashotsType).map((t) => t);

  return (
    <Box sx={styles}>
      <FormControl className={className} size="small">
        <InputLabel>{strings.label}</InputLabel>
        <Select
          className="rounded-[15px] border-0 text-left text-[14px]"
          disabled={options.length === 0}
          value={value?.toString() ?? "all"}
          label={strings.label}
          displayEmpty
          onChange={(v) => onSelect(v.target.value as AssetMetashotsType)}
          IconComponent={KeyboardArrowDownIcon}
        >
          <MenuItem value="all">{strings.options.all}</MenuItem>
          {options &&
            options.map((item) => (
              <MenuItem className="capitalize" key={item} value={item}>
                {item}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export const styles = {
  fieldset: {
    borderRadius: "15px",
    border: 0,
    boxShadow: "0px 0px 10px #00000021",
    legend: {
      display: "none",
    },
  },
  ".MuiSelect-select": {
    padding: "20px 10px 7px 15px",
    fontSize: "16px",
  },
  ".MuiInputLabel-root": {
    top: "4px",
    left: "14px",
    fontSize: "11px",
    transform: "none",
  },
};

type LocalSchema = {
  label: string;
  options: {
    all: string;
  };
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    label: "Metashot Type",
    options: {
      all: "All",
    },
  },
};
